// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aligncentre{
    text-align:center
}
.btn-primary{
    background-color:#797878
}`, "",{"version":3,"sources":["webpack://./src/app/inside-of-application/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;IACI;AACJ","sourcesContent":[".aligncentre{\r\n    text-align:center\r\n}\r\n.btn-primary{\r\n    background-color:#797878\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
